<template>
	<section class="kefu">
		<van-nav-bar title="客服咨询" left-arrow class="top_bar" @click-left="backFn" />	
		<div class="wx_code">
			<img :src="wxCodeImg">
		</div>
		<div class="saveImg" @click="downs">
			<img src="../../../assets/img/download_code.png">
			保存到相册
		</div>
		<div class="wx_num">
			<i>微信扫一扫，立即咨询</i>
			<p v-if="code"> 
				<input type="text" v-model="code"  id="copy_text" class="copyValue">
				<span @click="copyFn">用户码 {{code}}</span>
				<button class="tagRead"  data-clipboard-action="copy" data-clipboard-target="#copy_text" @click="copyFn" >（点击复制）</button>
			</p>
		</div>
	</section>
</template>

<script>
import Nav from "components/Nav"
import Clipboard from "clipboard";
// import wxCodeImg from "assets/img/kefu.png";
import { Notify } from 'vant';
import myServer from "api/my";




export default {
	name: 'kefu',
	components: {
		Nav,
	},
	data() {
		return {
			wxCodeImg: '',
			code: '',
		}
	},
	created() {
		this.code = localStorage.getItem('code')||''
		this.getInfo()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getInfo() {
			myServer.SearchKefu().then((res) => {
				this.wxCodeImg = res.data[0].wechatQrCode+'?response-content-type=application/octet-stream'
			})
		},
		
		downs () {
			kk_requestPhotoLibraryAuthorization((res)=>{
				if(res.code == 1) {
					kk_saveImage({url: this.wxCodeImg},(res)=>{
						alert('已保存到手机相册!');
					});
				}else {
					// alert('保存失败，请重试!'); 	
					Notify({ type: 'danger', message: '请打开图片权限' })
				}
			});
    	},
		copyFn() {
			var clipboard = new Clipboard(".tagRead");
			clipboard.on("success", e => {
				Notify({ type: 'success', message: '复制成功' });
				// 释放内存
				clipboard.destroy();
			});
			clipboard.on("error", e => {
				// 不支持复制
				Notify({ type: 'warning', message: '复制失败' });
				// 释放内存
				clipboard.destroy();
			});
    	},
		backFn() {
			this.$router.push({name:'user'})
		},
	}
}
</script>

<style lang="scss">
	.kefu {
		padding-top: 46px;
		.wx_code {
			width: 160px;
			height: 160px;
			margin: 0 auto;
			margin-top: 64px;
			margin-bottom: 38px;
			background: #fff;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				width: 130px;
			}
		}
		.saveImg {
			position: relative;
			font-size: 16px;
			margin: 0 auto;
			font-weight: bold;
			color: #fff;
			height: 36px;
			line-height: 36px;
			text-align: center;
			width: 160px;
			border-radius: 18px;
			background: #000;
			background: #3A5EEC;
			display: flex;
			align-items: center;
			justify-content: center;
			a {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				z-index: 2;
				opacity: 0;
				border-radius: 18px;
			}
			img {
				width: 19px;
				margin-right: 2px;
			}
		}
		.wx_num {
			padding-top: 37px;
			text-align: center;
			i {
				display: block;
				font-style: normal;
				color: #2B2F3A;
				font-size: 16px;
				padding-bottom: 18px;
			}
			p {
				.copyValue {
					position: absolute;
					z-index: -1;
					opacity: 0;
				}
				span {
					color: #2B2F3A;
					font-size: 16px;
					display: inline-block;
				}
				.tagRead {
					color: #3A5EEC;
					font-size: 15px;
					font-weight: bold;
					margin-left: 6px;
					border: 0;
					background: transparent;
					
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/kefu/Kefu.vue